import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { getOfferBanner } from "../../../features/home/homeSlice";
import "./Offer_Banner.css";

const Offer_Banner = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const apiOffers = useSelector((state) => state.home.offerBanners);

  useEffect(() => {
    dispatch(getOfferBanner());
  }, [dispatch]);

  const offers = apiOffers || [];

  if (!offers.length) return null;

  return (
    <section className="Offer_Banner">
      <div className="container-fluid">
         <div className="heading_holder">
          <h4 className="heading_text"> Offer Product</h4>
        </div>
        <Swiper
          className="offer_banner_swiper"
          modules={[Pagination, Autoplay]}
          pagination={{ clickable: true }}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          loop={offers.length > 2}
          breakpoints={{
            0: { slidesPerView: 1, spaceBetween: 10 },
            768: { slidesPerView: 3, spaceBetween: 16 },
          }}
        >
          {offers.map((offer, index) => (
            <SwiperSlide key={offer?.id || index}>
              <img
                className="offer_banner_img"
                src={process.env.REACT_APP_IMG_URL + offer?.image}
                alt="offer-banner"
                style={{ cursor: "pointer" }}
                onClick={() =>
                  navigate("/categories", {
                    state: { category_id: offer?.category_id, offered_only: true },
                  })
                }
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default Offer_Banner;
